import { render, staticRenderFns } from "./DPlayerSettingText2Speech.vue?vue&type=template&id=bde9f47a&"
import script from "./DPlayerSettingText2Speech.vue?vue&type=script&lang=js&"
export * from "./DPlayerSettingText2Speech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports